// extracted by mini-css-extract-plugin
export var category = "_hu-9";
export var categoryHeader = "_hu-e";
export var container = "_hu-0";
export var group = "_hu-a";
export var groupItems = "_hu-f";
export var groupSeparator = "_hu-j";
export var loading = "_hu-1";
export var noResults = "_hu-3";
export var placeholder = "_hu-2";
export var resultContent = "_hu-5";
export var resultIcon = "_hu-c";
export var resultItem = "_hu-g";
export var resultMeta = "_hu-8";
export var resultSubtitle = "_hu-7";
export var resultSuffix = "_hu-i";
export var resultTitle = "_hu-6";
export var resultsList = "_hu-4";
export var searchGroup = "_hu-d";
export var selected = "_hu-h";
export var subgroup = "_hu-b";